import QuillBlock from 'quill/blots/block';
import Annotation from './Annotation';
import Comment from './Comment';
import Diff from './Diff';
import Reaction from './Reaction';
import UserSequence from './UserSequence';
import VersionChange from './VersionChange';

const isAllowedInTitleLine = (attributeName: string) =>
  [
    Diff.attrName,
    VersionChange.attrName,
    Comment.attrName,
    Annotation.attrName,
    Reaction.attrName,
    UserSequence.attrName,
  ].includes(attributeName);

export default class Block extends QuillBlock {
  format(...args: Parameters<QuillBlock['format']>) {
    if (this.isTitleLine) return;
    super.format(...args);
  }

  formatAt(index: number, length: number, name: string, value: unknown) {
    if (this.isTitleLine && !isAllowedInTitleLine(name)) {
      return;
    }

    const Attributor = [Diff, VersionChange, UserSequence].find(
      (attributor) => attributor.attrName === name,
    );
    if (Attributor) {
      const blockLength = this.length();
      if (index + length === blockLength) {
        this.attributes.attribute(Attributor, value);
        if (length > 1) {
          super.formatAt(index, length - 1, name, value);
        }
        return;
      }
    }
    super.formatAt(index, length, name, value);
  }

  get isTitleLine() {
    // @ts-expect-error
    return !this.scroll.noTitleLine && this.prev == null;
  }
}
